let resumeData = {
    imagebaseurl: "https://github.com/uttamdeshani",
    name: "Uttam Deshani",
    role: "Junior ReactJS Developer by Day, MERN Stack Freelancer by Night",
    linkedinId: "https://www.linkedin.com/in/uttamdeshani/",
    skypeid: "https://join.skype.com/invite/YcwabIi9z9TE",
    roleDescription: "   ",
    socialLinks: [
        {
            name: "linkedin",
            url: "https://www.linkedin.com/in/uttamdeshani/",
            className: "fa fa-linkedin",
        },
        {
            name: "github",
            url: "https://github.com/uttamdeshani",
            className: "fa fa-github",
        },
        {
            name: "twitter",
            url: "https://twitter.com/UttamDeshani",
            className: "fa fa-twitter",
        },
        {
            name: "facebook",
            url: "https://www.facebook.com/Uttam.Deshani/",
            className: "fa fa-facebook",
        },
        {
            name: "instagram",
            url: "https://www.instagram.com/uttam_deshani/",
            className: "fa fa-instagram",
        },
        {
            name: "skype",
            url: "https://join.skype.com/invite/YcwabIi9z9TE",
            className: "fa fa-skype",
        },
    ],
    aboutme:
        "I'm a Full Stack Developer Proficient in MERN Stack. Currently, I'm working at The One Technologies as a Junior ReactJS Developer.",
    address: "Vadodara, Gujarat, India",
    email: "uttamdeshani@gmail.com",
    website: "https://uttam-deshani.netlify.app",
    education: [
        {
            UniversityName: "Shree Guru Jagaji Maharaj Vidhya Mandir, Sokhda",
            specialization: "SSC",
            MonthOfPassing: "March",
            YearOfPassing: "2014",
            Achievements: "Passed out with 72.16%",
        },
        {
            UniversityName: "Government Polytechnic, Ahmedabad",
            specialization: "Diploma in Computer Engineering",
            MonthOfPassing: "March",
            YearOfPassing: "2017",
            Achievements: "Graduated with CGPA: 7.28",
        },
        {
            UniversityName: "Government Engineering College, Dahod",
            specialization: "Bachelor of Computer Engineering",
            MonthOfPassing: "July",
            YearOfPassing: "2020",
            Achievements: "Graduated with CGPA: 7.70",
        },
    ],
    work: [
        {
            CompanyName: "The One Technologies",
            specialization: "Software Trainee",
            MonthOfLeaving: "September",
            YearOfLeaving: "2020",
            Achievements:
                "Starting from HTML, CSS, JavaScript, Bootstrap, MySQL, MongoDB, ExpressJS and ReactJS. I have completed all the basic training in Web Development starting from Beginner to Expert Level.",
        },
        {
            CompanyName: "The One Technologies",
            specialization: "Junior ReactJS Developer",
            MonthOfLeaving: "Present",
            YearOfLeaving: "",
            Achievements:
                "Currently, I am working on ReactJS Web Application Project. Web Applications have ReactJS Frontend and ExpressJS Backend. For designing, I have used Material UI, Ant Design, Bootstrap, and Reactstrap. Also, I have built extra functionalities using npm packages such as AWS-SDK, react-sortableJS, jsPDF, pdf-lib, cropperJS. Also, I have used react-redux for data management. I have also completed one other project of ElectronJS and ReactJS to Track user activity with random screenshots, Active-Idle state, and random videos of desktop screens of the system.",
        },
    ],
    skillsDescription:
        "I am a Junior ReactJS Developer at The One Technologies. My area of expertise is in ReactJS to build a web application as well as a cross-platform desktop application for Windows, Linux, and Mac OS using ElectronJS. I am also an expert in building ExpressJS Backend using the MySql database and MongoDB.",
    skills: [
        {
            skillname: "ReactJS",
            level: "100%",
        },
        {
            skillname: "ElectronJS",
            level: "55%",
        },
        {
            skillname: "ExpressJs",
            level: "80%",
        },
        {
            skillname: "MongoDB",
            level: "80%",
        },
        {
            skillname: "HTML5",
            level: "80%",
        },
        {
            skillname: "CSS3",
            level: "95%",
        },
        {
            skillname: "Git",
            level: "60%",
        },
    ],
    portfolio: [
        {
            name: "project1",
            description: "mobileapp",
            imgurl: "images/portfolio/phone.jpg",
        },
        {
            name: "project2",
            description: "mobileapp",
            imgurl: "images/portfolio/project.jpg",
        },
        {
            name: "project3",
            description: "mobileapp",
            imgurl: "images/portfolio/project2.png",
        },
        {
            name: "project4",
            description: "mobileapp",
            imgurl: "images/portfolio/phone.jpg",
        },
    ],
    testimonials: [
        {
            description:
                " #Kudos I am continually impressed by the results you produce! #GreatJob #thankyou",
            name: "Rakesh Thakor (Co-Founder at The One Technologies)",
        },
    ],
};

export default resumeData;
